import React from "react";
import { Link} from "react-router-dom";
// reactstrap components
import {
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavItem,
  Nav,
  NavLink,
  Container
} from "reactstrap";

import Funciones from "../../views/Molda/Funciones.js";
import Organigrama from "../../views/Molda/Organigrama.js";
import Tramites from "../../views/Molda/Tramites.js";

function DropdownWhiteNavbar() {
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const[Modal1,setModal1] = React.useState(false);
  const[Modal2,setModal2] = React.useState(false);
  const[Modal3,setModal3] = React.useState(false);
  return (
    <>
      {collapseOpen ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar className="bg-white fixed-top" expand="lg" style={{ minHeight: "auto" }}>
        <Container>
          <div className="navbar-translate">
            <NavbarBrand to="/" tag={Link} id="navbar-brand" style={{ padding: "5px 0" }}>
              <img
                alt="Logo de la notaria 27 de Bogotá"
                style={{ width: "120px", height: "auto" }}
                src={require("assets/img/notarias/logo27.png")}
              />
            </NavbarBrand>
            <button
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setCollapseOpen(!collapseOpen);
              }}
              aria-expanded={collapseOpen}
              className="navbar-toggler"
            >
              <span className="navbar-toggler-bar top-bar"></span>
              <span className="navbar-toggler-bar middle-bar"></span>
              <span className="navbar-toggler-bar bottom-bar"></span>
            </button>
          </div>
          <Collapse isOpen={collapseOpen} navbar>
            <Nav className="ml-auto" id="ceva" navbar>
              <NavItem>
                <NavLink href="/">
                  <i aria-hidden={true} className="now-ui-icons shopping_shop"></i>
                  <p>Inicio</p>
                </NavLink>
              </NavItem>
              <UncontrolledDropdown nav>
                <DropdownToggle
                  caret
                  color="default"
                  data-toggle="dropdown"
                  href="#"
                  id="navbarDropdownMenuLink1"
                  nav
                  onClick={(e) => e.preventDefault()}
                >
                  <i className="now-ui-icons tech_laptop"></i>
                  <p>Servicios en línea</p>
                </DropdownToggle>
                <DropdownMenu aria-labelledby="navbarDropdownMenuLink1" end>
                  <DropdownItem href="https://documentosnotariales.com/?n=d61e4568-ec50-450f-904c-b478e09d9a1c" target="_blank">
                    <i className="now-ui-icons files_single-copy-04"></i>
                    Solicitud de Copias
                  </DropdownItem>
                  <DropdownItem to="/cotizar" tag={Link}>
                    <i className="now-ui-icons business_money-coins"></i>
                    Cotizador
                  </DropdownItem>
                  <DropdownItem to="/cotizar" tag={Link}>
                    <i className="now-ui-icons business_briefcase-24"></i>
                    Clientes corporativos
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              <UncontrolledDropdown nav>
                <DropdownToggle
                  caret
                  color="default"
                  data-toggle="dropdown"
                  href="#"
                  id="navbarDropdownMenuLink"
                  nav
                  onClick={(e) => e.preventDefault()}
                >
                  <i aria-hidden={true} className="now-ui-icons business_badge"></i>
                  <p>Conócenos</p>
                </DropdownToggle>
                <DropdownMenu aria-labelledby="navbarDropdownMenuLink" end>
                  <DropdownItem to="/mision_vision" tag={Link}>
                    <i className="now-ui-icons files_single-copy-04"></i>
                    Misión y Visión
                  </DropdownItem>
                  <DropdownItem onClick={() => setModal1(true)}>
                    <i className="now-ui-icons users_circle-08"></i>
                    Funciones y deberes
                  </DropdownItem>
                  <DropdownItem to="/procesos" tag={Link}>
                    <i className="now-ui-icons ui-2_settings-90"></i>
                    Procesos y procedimiento
                  </DropdownItem>
                  <DropdownItem onClick={() => setModal2(true)}>
                    <i className="now-ui-icons design_image"></i>
                    Organigrama
                  </DropdownItem>
                  <DropdownItem to="/#cotizador" tag={Link}>
                    <i className="now-ui-icons education_paper"></i>
                    Noticias
                  </DropdownItem>
                  <DropdownItem to="/notario" tag={Link}>
                    <i className="now-ui-icons business_badge"></i>
                    Notario
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              <UncontrolledDropdown nav>
                <DropdownToggle
                  caret
                  color="default"
                  data-toggle="dropdown"
                  href="#"
                  id="navbarDropdownMenuLink2"
                  nav
                  onClick={(e) => e.preventDefault()}
                >
                  <i className="now-ui-icons education_paper"></i>
                  <p>Trámites</p>
                </DropdownToggle>
                <DropdownMenu aria-labelledby="navbarDropdownMenuLink2" end>
                  <DropdownItem onClick={() => setModal3(true)}>
                    <i className="now-ui-icons education_agenda-bookmark"></i>
                    Información
                  </DropdownItem>
                  <DropdownItem to="/servicio" tag={Link}>
                    <i className="now-ui-icons files_paper"></i>
                    Servicios
                  </DropdownItem>
                  <DropdownItem to="/tarifa" tag={Link}>
                    <i className="now-ui-icons business_money-coins"></i>
                    Tarifas
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              <NavItem>
                <NavLink href="/#contacto">
                  <i aria-hidden={true} className="now-ui-icons location_pin"></i>
                  <p>Contáctenos</p>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/transparencia/0">
                  <i aria-hidden={true} className="now-ui-icons ui-1_zoom-bold"></i>
                  <p>Transparencia</p>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#" onClick={(e) => e.preventDefault()} style={{ opacity: 0.5, cursor: "default" }}>
                  <i aria-hidden={true} className="now-ui-icons business_globe"></i>
                  <p>Notaría Virtual</p>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/participa">
                  <i aria-hidden={true} className="now-ui-icons files_paper"></i>
                  <p>Participa</p>
                </NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
      <Funciones modal={Modal1} setModal={() => setModal1(false)} />
      <Organigrama modal={Modal2} setModal={() => setModal2(false)}/>
      <Tramites modal={Modal3} setModal={() => setModal3(false)}/>
    </>
  );
}

export default DropdownWhiteNavbar;
